/**
 * Intercept signup CTA clicks on public pages.
 *
 * This helper is only enabled in unit tests now that the 17906 experiment is
 * ended. Future experiments can reuse the helper by adding a new explicit gate.
 */
import {
  getClosestElement,
  getSignupUrl,
  openModalOrRedirect,
  redirectToSignup,
} from '@/pages-signup-modal/interception.helpers'

/**
 * Start signup CTA interception for public pages.
 */
export function initSignupCtaInterception17906(): () => void {
  if (window.__UNIT_TESTING !== true) {
    return (): void => {}
  }

  document.addEventListener('click', handleSignupCtaClick, true)

  return (): void => {
    document.removeEventListener('click', handleSignupCtaClick, true)
  }
}

/**
 * Intercept signup link clicks and route them through the experiment flow.
 */
export function handleSignupCtaClick(event: MouseEvent): void {
  if (shouldSkipClick(event)) {
    return
  }

  const anchor = getClosestElement<HTMLAnchorElement>(event.target, 'a')
  const signupUrl = getSignupUrl(anchor)

  if (!signupUrl) {
    return
  }

  event.preventDefault()
  // The `void` marks the async call as intentionally fire-and-forget.
  void openModalOrRedirect(signupUrl, () => redirectToSignup(signupUrl))
}

/**
 * Skip clicks that should keep normal browser behavior.
 */
function shouldSkipClick(event: MouseEvent): boolean {
  return (
    event.defaultPrevented ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey
  )
}
